import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CriteoAlignmentComponent } from './criteo-alignment.component';

@NgModule({
  declarations: [CriteoAlignmentComponent],
  imports: [CommonModule],
  exports: [CriteoAlignmentComponent],
})
export class CriteoAlignmentModule {}
